import { resolveMetric, sourceLabel, type MetricChain } from '@/api/metric-resolution';
import { StatTile } from './StatTile';

interface ResolvedTileProps {
  label: string;
  totals: Record<string, number> | undefined;
  chain: MetricChain;
  tone?: 'default' | 'warning' | 'critical';
  /** Overrides the automatic provenance line. */
  sub?: string;
}

/**
 * A stat tile whose value is resolved through the provider-precedence policy.
 *
 * GA4 wins wherever GA4 measures the thing; Clarity answers only where GA4 cannot. The tile then
 * STATES which provider answered, because the two do not agree and are not meant to: Clarity
 * counts bot sessions GA4 filters out, and ad-blockers suppress GA4 more aggressively than
 * Clarity. A tile that silently swapped provider would show a number that moved for reasons
 * nothing on the page could explain.
 */
export function ResolvedTile({ label, totals, chain, tone = 'default', sub }: ResolvedTileProps) {
  const resolved = resolveMetric(totals, chain);

  return (
    <StatTile
      label={label}
      value={resolved?.value ?? null}
      tone={tone}
      // When GA4 was expected but Clarity answered, sourceLabel says so explicitly rather than
      // just naming Clarity — the fallback is the interesting part.
      sub={sub ?? sourceLabel(resolved)}
    />
  );
}
